<template>
  <div class="d-flex justify-content-end">
    <div>
      {{ paginateStart }} - {{ paginateStart + items.length - 1 }} of
      {{ totalItems }}
    </div>
  </div>
</template>

<script>
import { channels } from "../mixins/channels";
export default {
  props: ["paginateStart", "items", "totalItems"],
  mixins: [channels],
};
</script>

<style></style>
